import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import PouchDB from 'pouchdb';
import PouchDBFind from 'pouchdb-find';

PouchDB.plugin(PouchDBFind);
interface ThematiqueDoc {
  _id: string;
  name: string;
  contexte: string;
  objectifs: string;
  points: string;
}

@Injectable({
  providedIn: 'root',
})
export default class ThematiqueService {
  private db = new PouchDB('causerie_thematiques');

  all(): Observable<ThematiqueDoc[]> {
    const promise = this.db
      .find({
        selector: { type: 'thematique' },
      })
      .then((res) => res.docs as unknown as ThematiqueDoc[]);

    return from(promise);
  }

  public loadPdfFromCouch(id: string) {
    const promise = this.db.getAttachment(id, 'file').then((res) => res);

    return from(promise);
  }

  public getThematique(id: string) {
    const promise = this.db
      .find({
        selector: {
          _id: id,
        },
      })
      .then((res) => {
        return res.docs[0] as unknown as ThematiqueDoc;
      });

    return from(promise);
  }
}
